<script lang="ts">
    export let tag: string;
    export let text: string;
</script>

<h3 id={tag}>{text}</h3>

<style>
</style>